import React from 'react';
import { Paper, Box, Text, Grid, Divider, Title } from '@mantine/core';
import useAuthenticatedData from '../../hooks/useAuthenticatedData'; // Adjust the import path as needed
import VersionHistory from './VersionHistory'; // Adjust the import path as needed

const About = () => {
  return (
    <Paper shadow="md"  style={{ maxWidth: '100%'  }}>
       <Text
              component="h1"
              style={{
                fontFamily: 'Orbitron, sans-serif',
                color: '#FDB813',
                fontStyle: 'italic',
                fontSize: '1.5rem',
                marginBottom: '16px',
                textAlign: 'left'
              }}
            >
        About Nexus
    </Text>
      <Box mt="md">
        <Grid>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Title order={6} mb="sm">
              Current Application Info
            </Title>
            <Divider my="md" />
            <Text mb="sm">
              Version: {process.env.REACT_APP_VERSION}
            </Text>
            <Text mb="sm">
              Environment: {process.env.NODE_ENV}
            </Text>
          </Grid.Col>
          
          <Grid.Col span={{ base: 12, md: 8 }}>
            <Title order={6} mb="sm">
              Version History
            </Title>
            <Divider my="md" />
            <VersionHistory />
          </Grid.Col>
        </Grid>
      </Box>
    </Paper>
  );
};

export default About;